import { render, staticRenderFns } from "./StudentProfilEdit.vue?vue&type=template&id=ea56875e&"
import script from "./StudentProfilEdit.vue?vue&type=script&lang=js&"
export * from "./StudentProfilEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfilEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports